import {Alert, AlertProps} from 'antd';
import React from 'react';

export interface AlertDescriptionProps extends AlertProps {
  message?: AlertProps['message'];
  description?: AlertProps['description'];
}

const DEFAULT_MESSAGE = 'Note';

const AlertDescription: React.FC<AlertDescriptionProps> = ({
  type = 'info',
  showIcon = true,
  closable = false,
  message = DEFAULT_MESSAGE,
  description,
  ...rest
}) => {
  return (
    <Alert
      type={type}
      showIcon={showIcon}
      closable={closable}
      message={message}
      {...(description !== undefined && description !== null ? {description} : {})}
      {...rest}
    />
  );
};

export default AlertDescription;
